// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3FLOn","title":"AfterFrontImage_title__1BJ2K"};